/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { AmountEuroCents } from "./AmountEuroCents";
import { PaymentInstrumentDetail } from "./PaymentInstrumentDetail";
import * as t from "io-ts";
import { enumType } from "@pagopa/ts-commons/lib/types";

export enum LanguageEnum {
  "IT" = "IT",

  "EN" = "EN",

  "FR" = "FR",

  "DE" = "DE",

  "SL" = "SL"
}

/**
 * Request body for requesting an authorization for a transaction
 */

// required attributes
const RequestAuthorizationRequestR = t.interface({
  amount: AmountEuroCents,

  fee: AmountEuroCents,

  paymentInstrumentId: t.string,

  pspId: t.string,

  language: enumType<LanguageEnum>(LanguageEnum, "language"),

  isAllCCP: t.boolean,

  details: PaymentInstrumentDetail
});

// optional attributes
const RequestAuthorizationRequestO = t.partial({});

export const RequestAuthorizationRequest = t.intersection(
  [RequestAuthorizationRequestR, RequestAuthorizationRequestO],
  "RequestAuthorizationRequest"
);

export type RequestAuthorizationRequest = t.TypeOf<
  typeof RequestAuthorizationRequest
>;
